import { Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { CommonModule } from "@angular/common";
import { PickListModule } from "primeng/picklist";
import { LoaderService } from "../../../../core/services/loader.service";
import { SharedService } from "../../../../core/services/shared.service";
import { ShippingMethod } from "../../../../core/models/samplePO/details/shippingMethod";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { ManagementService } from "../../../../core/services/management.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";

@UntilDestroy()
@Component({
  selector: "jni-shipping-method-order",
  templateUrl: "./shipping-method-order.component.html",
  styleUrls: ["./shipping-method-order.component.scss"],
  imports: [
    CommonModule,
    PickListModule,
    ButtonModule,
    CardModule,
    SpinnerComponent,
  ],
})
export class ShippingMethodOrderComponent implements OnInit {
  shippingMethodProductsList: ShippingMethod[] = [];
  targetShippingMethodProductsList: ShippingMethod[] = [];
  showSmallLoader = true;

  constructor(
    private _samplepoListingService: SamplepoListingService,
    private _loaderService: LoaderService,
    private _managementService: ManagementService,
    private _toastr: JniToastrService,
    private _sharedService: SharedService
  ) {}

  ngOnInit() {
    this.getAllShippingMethod();
    this.showSmallLoader = false;
    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  getAllShippingMethod() {
    this._samplepoListingService
      .getAllShippingMethod()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const shippingData = res.data;
          this.shippingMethodProductsList = shippingData.filter(
            x => x.jniUseOnSalesOrderD365 !== "No"
          );
        },
      });
  }

  shippingMethodOrderUpdate() {
    this._loaderService.setLoaderState(true);
    this._managementService
      .shippingMethodOrderUpdate(this.shippingMethodProductsList)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this._toastr.success(
              "Success",
              "Shipping Method Orders are updated successfully"
            );
          }
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._toastr.error("Error", "No record is updated");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getIndexById(id: number) {
    return this.shippingMethodProductsList.findIndex(x => x.id == id) + 1;
  }
}
